/**
 * ヘッダー全体にクラス名「js-gnav」
 * ヘッダーメニューにクラス名「js-gnav-navbar」
 * ハンバーガーメニューにクラス名「js-gnav-toggle」
 * グローバルメニューにクラス名「js-gnav-menu」
 */

jQuery(function($) {
	// PC時のナビゲーションの動き
	// ===========================
	// var $win = $(window),
	//     $cloneNav = $('.js-gnav').clone().addClass('js-gnav-clone').appendTo('body'),
	//     showClass = 'is-show';

	// $win.on('load scroll', function() {
	//   var value = $(this).scrollTop();
	// 	if (window.matchMedia('(min-width: 769px)').matches) {
	// 		if ( value > 700 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	} else {
	// 		if ( value > 280 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	}
	// });

	// スマホメニューの切り替え
	// ===========================
	var gnavBreakpointSp = 1199;
	var gnavWrapperClass = $('.js-gnav'); // ナビゲーション全体を囲んでいるクラス名
	var gnavNavClass = $('.js-gnav-nav, .js-gnav-pc'); // ナビバーを囲んでいるクラス名
	var gnavToggleClass = $('.js-gnav-toggle'); // トグルメニューのクラス名
	var activeClass = 'is-active'; // アクティブ時のクラス名

	$(window).on('load scroll', function() {
		var h = $(this).scrollTop();
		if (h > 700) {
			gnavWrapperClass.addClass('is-fixed');
		} else {
			gnavWrapperClass.removeClass('is-fixed');
			if (!gnavWrapperClass.hasClass(activeClass)) {
				gnavWrapperClass.removeClass('no-anim');
			}
		}
	});

	function menuOpen() {
		gnavWrapperClass.toggleClass(activeClass);

		if (gnavWrapperClass.hasClass(activeClass)) {
			gnavWrapperClass.addClass('no-anim');
			gnavToggleClass.addClass(activeClass);
			gnavNavClass.addClass(activeClass);
			bodyFix();
		} else {
			if (!gnavWrapperClass.hasClass('is-fixed')) {
				gnavWrapperClass.removeClass('no-anim');
			}
			gnavToggleClass.removeClass(activeClass);
			gnavNavClass.removeClass(activeClass);
			bodyFixReset();
		}
	}

	gnavToggleClass.on('click', function(e) {
		e.stopPropagation();
		e.preventDefault();
		menuOpen();
	});

	$('.js-header-toggle').on('click', function(e) {
		e.stopPropagation();
		e.preventDefault();
		menuOpen();
	});

	$('.js-gnav-close').on('click', function() {
		gnavWrapperClass.removeClass(activeClass);

		if (!gnavWrapperClass.hasClass('is-fixed')) {
			gnavWrapperClass.removeClass('no-anim');
		}
		gnavToggleClass.removeClass(activeClass);
		gnavNavClass.removeClass(activeClass);
		bodyFixReset();
	});

	$(document).on('click', function(e) {
		if (!$(e.target).closest('.js-gnav-navbar').length && $(gnavWrapperClass).hasClass(activeClass)) {
			menuOpen();
		}
	});

	// SP ドロップダウンメニュー
	// ===========================
	var gnavMenuClass = $('.js-gnav-menu');
	var gnavMenuItemsLevel1 = $('.js-gnav-menu>ul>li');

	$('.page_item_has_children > a', gnavMenuClass).on('click', function(e) {
		if (window.matchMedia('(max-width: ' + gnavBreakpointSp + 'px)').matches) {
			e.stopPropagation();
			e.preventDefault();
			let children = $(this).next('.children');
			gnavMenuItemsLevel1.each(function() {
				let find = $(this).find(children);
				if (!find.length) {
					$('.children', $(this)).slideUp(300);
				}
			});
			children.slideToggle(300);
			return false;
		}
	});
});
